import type { FC } from 'react';

import { Icon, Tooltip, Typography } from 'pixel-react';

import styles from './Profile.module.scss';
import type { ProfileImageProps } from './type';
const ProfileImage: FC<ProfileImageProps> = ({
  imagePreview,
  handleImageUpload,
  handleEditProfileImage,
  editImageClicked,
  handleRemoveFile,
}) => {
  return (
    <>
      {imagePreview ? (
        <img
          src={imagePreview}
          alt="Profile Preview"
          className={styles.avatar_image}
        />
      ) : (
        <Icon
          color="var(--brand-color)"
          height={85}
          name="user_profile"
          width={65}
        />
      )}
      <div className={imagePreview ? styles.edit_icon : styles.upload_icon}>
        <Tooltip
          title={imagePreview ? 'Edit Profile Image' : 'Upload Profile Image'}
        >
          <Icon
            color="var(--brand-color)"
            name={imagePreview ? 'edit' : 'upload_profile_image'}
            onClick={!imagePreview ? handleImageUpload : handleEditProfileImage}
            width={imagePreview ? 0 : 40}
            height={imagePreview ? 0 : 40}
          />
        </Tooltip>
      </div>
      {editImageClicked && (
        <div className={styles.options_container}>
          <span
            className={styles.replace_container}
            onClick={handleImageUpload}
          >
            <Icon name="replace_file" />
            <Typography fontWeight="medium" fontSize={10} lineHeight="15px">
              Replace
            </Typography>
          </span>
          <span className={styles.remove_container} onClick={handleRemoveFile}>
            <Icon name="unfollow_icon" />
            <Typography fontWeight="medium" fontSize={10} lineHeight="15px">
              Remove
            </Typography>
          </span>
        </div>
      )}
    </>
  );
};

export default ProfileImage;
